const MEDIA_LIBRARY_ARCHIVE = "media-library::archive";
const MEDIA_LIBRARY_ARCHIVE_ERROR = "media-library::archive::error";
const MEDIA_LIBRARY_ARCHIVE_SUCCESS = "media-library::archive::success";

function mediaLibraryArchiveAction(payload, successMessage = "") {
  const { items } = payload;
  return {
    payload: {
      successMessage,
      serviceArgs: [items],
    },
    type: MEDIA_LIBRARY_ARCHIVE,
  };
}

export {
  MEDIA_LIBRARY_ARCHIVE,
  MEDIA_LIBRARY_ARCHIVE_ERROR,
  MEDIA_LIBRARY_ARCHIVE_SUCCESS,
  mediaLibraryArchiveAction,
};
